export var FALLBACK_LOCALE = 'fr';
export var buildCandidateLocales = function (userLocale, defaultLocale) {
    var candidates = [userLocale, defaultLocale, FALLBACK_LOCALE].filter(function (locale) { return typeof locale === 'string' && locale.trim().length > 0; });
    return Array.from(new Set(candidates));
};
export var isI18nObject = function (payload) {
    return typeof payload === 'object' && payload !== null && !Array.isArray(payload);
};
export var getValidI18nPayload = function (response) {
    if (!response || response.error || !isI18nObject(response.payload)) {
        return null;
    }
    return response.payload;
};
